import { render, staticRenderFns } from "./FeatureAttachmentForm.vue?vue&type=template&id=08c609be"
import script from "./FeatureAttachmentForm.vue?vue&type=script&lang=js"
export * from "./FeatureAttachmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports